/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { NetSuiteShipmentStatus } from "./NetSuiteShipmentStatus";
import {
  NetSuiteShipmentStatusFromJSON,
  NetSuiteShipmentStatusFromJSONTyped,
  NetSuiteShipmentStatusToJSON,
  NetSuiteShipmentStatusToJSONTyped,
} from "./NetSuiteShipmentStatus";
import type { Shipment } from "./Shipment";
import {
  ShipmentFromJSON,
  ShipmentFromJSONTyped,
  ShipmentToJSON,
  ShipmentToJSONTyped,
} from "./Shipment";

/**
 *
 * @export
 * @interface ShipmentStatusComparison
 */
export interface ShipmentStatusComparison {
  /**
   *
   * @type {NetSuiteShipmentStatus}
   * @memberof ShipmentStatusComparison
   */
  netsuite: NetSuiteShipmentStatus;
  /**
   *
   * @type {Shipment}
   * @memberof ShipmentStatusComparison
   */
  shipment?: Shipment | null;
  /**
   *
   * @type {boolean}
   * @memberof ShipmentStatusComparison
   */
  presentInFreightSimple: boolean;
  /**
   *
   * @type {string}
   * @memberof ShipmentStatusComparison
   */
  expectedNetSuiteStatus?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof ShipmentStatusComparison
   */
  inSync: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ShipmentStatusComparison
   */
  statusDrift: boolean;
}

/**
 * Check if a given object implements the ShipmentStatusComparison interface.
 */
export function instanceOfShipmentStatusComparison(
  value: object,
): value is ShipmentStatusComparison {
  if (!("netsuite" in value) || value["netsuite"] === undefined) return false;
  if (
    !("presentInFreightSimple" in value) ||
    value["presentInFreightSimple"] === undefined
  )
    return false;
  if (!("inSync" in value) || value["inSync"] === undefined) return false;
  if (!("statusDrift" in value) || value["statusDrift"] === undefined)
    return false;
  return true;
}

export function ShipmentStatusComparisonFromJSON(
  json: any,
): ShipmentStatusComparison {
  return ShipmentStatusComparisonFromJSONTyped(json, false);
}

export function ShipmentStatusComparisonFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentStatusComparison {
  if (json == null) {
    return json;
  }
  return {
    netsuite: NetSuiteShipmentStatusFromJSON(json["netsuite"]),
    shipment:
      json["shipment"] == null ? undefined : ShipmentFromJSON(json["shipment"]),
    presentInFreightSimple: json["presentInFreightSimple"],
    expectedNetSuiteStatus:
      json["expectedNetSuiteStatus"] == null
        ? undefined
        : json["expectedNetSuiteStatus"],
    inSync: json["inSync"],
    statusDrift: json["statusDrift"],
  };
}

export function ShipmentStatusComparisonToJSON(
  json: any,
): ShipmentStatusComparison {
  return ShipmentStatusComparisonToJSONTyped(json, false);
}

export function ShipmentStatusComparisonToJSONTyped(
  value?: ShipmentStatusComparison | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    netsuite: NetSuiteShipmentStatusToJSON(value["netsuite"]),
    shipment: ShipmentToJSON(value["shipment"]),
    presentInFreightSimple: value["presentInFreightSimple"],
    expectedNetSuiteStatus: value["expectedNetSuiteStatus"],
    inSync: value["inSync"],
    statusDrift: value["statusDrift"],
  };
}
